
import { AvailabilityRecord, AvailabilityStatus, WorkCalendarRecord } from '../types';
import { createTimeSlot, TimeSlot, TimeSlotDTO } from './TimeSlot';

export type AvailabilityDateDTO = {
    dateTz: string;
    status: AvailabilityStatus;
    timeSlot: TimeSlotDTO | null;
}

export type AvailabilityDate = {
    date: string;
    timeSlots: TimeSlot[];
    status: AvailabilityStatus;
};

export function createAvailabilityDate(date: Date, record: WorkCalendarRecord | AvailabilityRecord | undefined | null): AvailabilityDate {
    return {
        date: date.toISOString(),
        timeSlots: (record?.timeSlots || []).map(s =>
            createTimeSlot(s.startTimeTz, s.finishTimeTz)),
        status: record?.status || 'Unknown'
    };
}

export function createWorkItemDate(date: Date, record: Partial<WorkCalendarRecord> | undefined | null): WorkCalendarRecord {
    return {
        date: date.toISOString(),
        timeSlots: (record?.timeSlots || []).map(s =>
            createTimeSlot(s.startTimeTz, s.finishTimeTz)),
        status: record?.status || 'Unknown',
        orders: record?.orders || []
    };
}

export function getDateObject(availabilityDate: WorkCalendarRecord): Date {
    return new Date(availabilityDate.date);
}

export function isAvailabilityDateEqual(date1: WorkCalendarRecord, date2: WorkCalendarRecord): boolean {
    return date1.date === date2.date;
}

export type ApplyAvailabilityDTO = AvailabilityDateDTO[];
